import React from 'react';
import { HiOutlineSearch, HiX } from 'react-icons/hi';
import Input from '@/components/ui/Input';

interface SearchInputProps {
  value: string;
  onChange?: (value: string) => void;
}

const SearchInput: React.FC<SearchInputProps> = ({ value, onChange }) => {
  const handleChange = (nextValue: string) => {
    onChange?.(nextValue);
  };

  return (
    <Input
      type="text"
      value={value}
      placeholder="Search notes"
      aria-label="Search notes"
      prefix={<HiOutlineSearch className="w-4 h-4 text-gray-400" />}
      suffix={
        value ? (
          <button
            type="button"
            onClick={() => handleChange('')}
            className="inline-flex h-6 w-6 items-center justify-center rounded-full text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors"
            aria-label="Clear search"
          >
            <HiX className="w-4 h-4" />
          </button>
        ) : null
      }
      onChange={(event) => handleChange(event.target.value)}
    />
  );
};

export default SearchInput;
